import { createAsyncTypes } from 'store/utils';
import { Venue } from 'store/venues';

// State Key
export const KEY = 'areas';

// Action Types
export const types = {
  GET_AREAS: createAsyncTypes(`${KEY}/GET_AREAS`),
  RESET_AREAS: `${KEY}/RESET_AREAS`,
  UPDATE_AREA: createAsyncTypes(`${KEY}/UPDATE_AREA`),
  RESET_ERROR: `${KEY}/RESET_ERROR`,
  CREATE_AREA: createAsyncTypes(`${KEY}/CREATE_AREA`),
  DELETE_AREA: createAsyncTypes(`${KEY}/DELETE_AREA`)
};

export interface AreasState {
  readonly areas: Area[];
  readonly action: {
    readonly success: boolean;
    readonly pending: boolean;
    readonly error: string | null;
  };
}

export interface Area {
  id: string;
  venueId: string;
  name: string;
  description: string;
  createdAt: string;
  updatedAt: string;
  venue?: Venue;
}

export interface CreateAreaRequest {
  type: typeof types.CREATE_AREA.REQUEST;
  payload: CreateAreaPayload;
}

export interface CreateAreaPayload {
  venueId: string;
  name: string;
  description?: string;
}

export interface ResetAreas {
  type: typeof types.RESET_AREAS;
}

export interface GetAreasRequest {
  type: typeof types.GET_AREAS.REQUEST;
  payload: {
    venueId: string;
  };
}

export interface GetAreasError {
  type: typeof types.GET_AREAS.ERROR;
  payload: string;
}

export interface GetAreasPending {
  type: typeof types.GET_AREAS.PENDING;
  payload: boolean;
}

export interface GetAreasSuccess {
  type: typeof types.GET_AREAS.SUCCESS;
  payload: Area[];
}

type UpdateAreaPayload = Partial<Area> & { id: string };

export interface UpdateAreaRequest {
  type: typeof types.UPDATE_AREA.REQUEST;
  payload: UpdateAreaPayload;
}

export interface UpdateAreaError {
  type: typeof types.UPDATE_AREA.ERROR;
  payload: string;
}

export interface UpdateAreaPending {
  type: typeof types.UPDATE_AREA.PENDING;
  payload: boolean;
}

export interface UpdateAreaSuccess {
  type: typeof types.UPDATE_AREA.SUCCESS;
  payload: Area;
}

export interface CreateAreaRequest {
  type: typeof types.CREATE_AREA.REQUEST;
  payload: CreateAreaPayload;
}

export interface CreateAreaError {
  type: typeof types.CREATE_AREA.ERROR;
  payload: string;
}

export interface CreateAreaPending {
  type: typeof types.CREATE_AREA.PENDING;
  payload: boolean;
}

export interface CreateAreaSuccess {
  type: typeof types.CREATE_AREA.SUCCESS;
}

export interface DeleteAreaRequest {
  type: typeof types.DELETE_AREA.REQUEST;
  payload: { id: string };
}

export interface DeleteAreaError {
  type: typeof types.DELETE_AREA.ERROR;
  payload: string;
}

export interface DeleteAreaPending {
  type: typeof types.DELETE_AREA.PENDING;
  payload: boolean;
}

export interface DeleteAreaSuccess {
  type: typeof types.DELETE_AREA.SUCCESS;
  payload: { id: string };
}

export type AreasActionTypes =
  | ResetAreas
  | GetAreasRequest
  | GetAreasSuccess
  | GetAreasError
  | GetAreasPending
  | UpdateAreaRequest
  | UpdateAreaSuccess
  | UpdateAreaError
  | UpdateAreaPending
  | CreateAreaRequest
  | CreateAreaSuccess
  | CreateAreaError
  | CreateAreaPending
  | DeleteAreaRequest
  | DeleteAreaSuccess
  | DeleteAreaError
  | DeleteAreaPending;
